// Copyright (c) StrangeBee 2023

import { useContext, useEffect } from 'react';
import { GlobalStreamSrv, ScopeProps, GlobalStreamLongPollingSrv } from '@Services/StreamSrv';
import { AuditOutput } from 'thehive-sdk';
import { StatusContext } from '@Context/StatusProvider';

export const useStreamObserver = (
    scope: ScopeProps,
    callBack: (audits: AuditOutput[]) => void,
    dep: any[] = [],
): void => {
    const { features } = useContext(StatusContext);
    useEffect(() => {
        const streamSrv = features.has('StreamSSE') ? GlobalStreamSrv : GlobalStreamLongPollingSrv;
        const removeObserver = streamSrv.addObserver(scope, callBack);
        return (): void => {
            removeObserver();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dep);
};
